import { createSlice } from "@reduxjs/toolkit";
import getGiftCardsApi from "../../../rtk-apis/hospital/getGiftCards";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const getGiftCardsSlice = createSlice({
  name: "getGiftCardsSlice",
  initialState,
  reducers: {
    clearGiftCards: (state: any) => {
      state.status = '';
      state.result = {};
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGiftCardsApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getGiftCardsApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getGiftCardsApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getGiftCardsSlice.reducer;
export const { clearGiftCards } = getGiftCardsSlice.actions;
